export default "__VITE_ASSET__DUr3yjjj__"